/**
 * Application Configuration
 * Centralized configuration values
 */

export const APP_CONFIG = {
  APP_NAME: "GIGAMINE",
  LOGO_PATH: "/assets/logo.svg",
  LOGIN_LOGO_PATH: "/assets/login_logo.svg",
  USER_ICON_PATH: "/assets/header/union.svg",
  QR_CODE_PATH: "/assets/popup_qr.svg",
  DOWNLOAD_QR_PATH: "/assets/download_qr.svg",
};

/**
 * API Configuration
 * Note: In production, these should come from environment variables
 */
export const API_CONFIG = {
  BASE_URL:
    process.env.REACT_APP_API_URL || "http://192.168.0.213:8083/v1/api/",
  TIMEOUT: 30000, // 30 seconds
  CONTENT_TYPE: "application/json",
};

/**
 * Storage Keys
 */
export const STORAGE_KEYS = {
  TOKEN: "token",
  USER: "user",
};

/**
 * Local Storage Helper Functions
 */
export const storage = {
  get: (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error reading from localStorage key "${key}":`, error);
      return null;
    }
  },
  set: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error writing to localStorage key "${key}":`, error);
    }
  },
  remove: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing from localStorage key "${key}":`, error);
    }
  },
  getString: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error(
        `Error reading string from localStorage key "${key}":`,
        error
      );
      return null;
    }
  },
  setString: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error(
        `Error writing string to localStorage key "${key}":`,
        error
      );
    }
  },
};
